export const XXXL = {
  MIN: 3000,
  TILES: 6
};
export const XXL = {
  MIN: 1600,
  MAX: 2999,
  TILES: 6
};
export const XL = {
  MIN: 1200,
  MAX: 1599,
  TILES: 4
};
export const L = {
  MIN: 992,
  MAX: 1199,
  TILES: 4
};
export const M = {
  MIN: 768,
  MAX: 991,
  TILES: 3
};
export const S = {
  MIN: 480,
  MAX: 767,
  TILES: 3
};
export const XS = {
  MIN: 0,
  MAX: 479,
  TILES: 2
};

export default {
  XXXL,
  XXL,
  XL,
  L,
  M,
  S,
  XS
};